import { useForkRef } from "@mui/material/utils";
import {
  DateRange,
  DateRangePickerFieldProps,
  usePickerContext,
  useSplitFieldProps
} from "@mui/x-date-pickers-pro";
import { format } from "date-fns";
import { Button, Chevron } from "./RangePickerButton.styles";

export const RangePickerButton = (props: DateRangePickerFieldProps) => {
  const { forwardedProps } = useSplitFieldProps(props, "date");

  const pickerContext = usePickerContext<DateRange<Date>>();
  const handleRef = useForkRef(pickerContext.triggerRef, pickerContext.rootRef);

  const formattedValue = pickerContext.value
    .map((value) => {
      return value ? format(value, "dd MMM yy") : "DD MMM YY";
    })
    .join(" - ");

  return (
    <Button
      {...forwardedProps}
      ref={handleRef}
      onClick={() => pickerContext.setOpen((prev) => !prev)}
      endIcon={<Chevron />}
    >
      {formattedValue}
    </Button>
  );
};
